import cogoToast from 'cogo-toast';

export const copyToClipboard = (str, logSuccess = false, logMsg = 'Copied to clipboard.') => {
  const el = document.createElement('textarea'); // Create a <textarea> element
  el.value = str; // Set its value to the string that you want copied
  el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible
  document.body.appendChild(el); // Append the <textarea> element to the HTML document
  const selected =
    document.getSelection().rangeCount > 0 // Check if there is any content selected previously
      ? document.getSelection().getRangeAt(0) // Store selection if found
      : false; // Mark as false to know no selection existed before
  el.select(); // Select the <textarea> content
  document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el); // Remove the <textarea> element
  if (selected) {
    // If a selection existed before copying
    document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
    document.getSelection().addRange(selected); // Restore the original selection
  }
  logSuccess && cogoToast.success(logMsg, { hideAfter: 1 });
};

export const isShareLink = () => window.location.href.includes('/s/');

export const getUrlParam = (param) => new URLSearchParams(window.location.search).get(param);

export const removeUrlParam = (param) => {
  const params = new URLSearchParams(window.location.href.split('?')[1]);
  params.delete(param);
  const newParams = params.toString();
  window.history.replaceState({}, document.title, window.location.href.split('?')[0] + (newParams.length ? `?${newParams}` : ''));
};

export const calculateAudioLength = (file) =>
  new Promise((resolve) => {
    var reader = new FileReader();
    var audio = document.createElement('audio');
    reader.onload = (e) => {
      audio.src = e.target.result;
      audio.addEventListener(
        'loadedmetadata',
        () => {
          resolve(parseInt(audio.duration));
        },
        false
      );
    };
    reader.onerror = (e) => {
      console.log('ERROR!', e);
    };
    reader.readAsDataURL(file);
  });
